import { render, staticRenderFns } from "./60.vue?vue&type=template&id=e28c5c0e&scoped=true&"
var script = {}
import style0 from "./60.vue?vue&type=style&index=0&id=e28c5c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28c5c0e",
  null
  
)

export default component.exports